// role enum, default '1' is new MIS
export const DEFAULT_PRODUCT_CODE = '1'
// export enum RoleEnum {
//   // super admin
//   SUPER = 'super',

//   // tester
//   TEST = 'test',
// }
